import { Guid } from '@web/utils';

export class PublicFaqQuestion {
  public constructor(
    private readonly data: {
      id: Guid;
      name: string;
      content: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get content(): string {
    return this.data.content;
  }
}
